import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=63a0be33&scoped=true"
import script from "./card-table.vue?vue&type=script&lang=js"
export * from "./card-table.vue?vue&type=script&lang=js"
import style0 from "./card-table.vue?vue&type=style&index=0&id=63a0be33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0be33",
  null
  
)

export default component.exports